import { Link } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';
import Breadcrumb from '@/components/feature/Breadcrumb';
import FaqAccordion from '@/components/feature/FaqAccordion';
import { useSeo } from '@/hooks/useSeo';
import { faqs } from '@/mocks/content';

const groupOrder = ['内容与来源', '使用与互动', '版权与隐私'];

export default function Faq() {
  useSeo({
    title: '常见问题 - 内容来源、讨论区规则与版权说明',
    description:
      '瓜田观察常见问题汇总：内容从哪里来、信息状态标签是什么意思、讨论区有哪些规则、如何投稿线索，以及涉及版权的处理方式，一次说清楚。',
    keywords: '常见问题,内容来源,讨论区规则,信息状态,线索投稿,版权与隐私,瓜田观察',
    path: '/faq',
    type: 'website',
    jsonLd: {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'FAQPage',
          mainEntity: faqs.map((item) => ({
            '@type': 'Question',
            name: item.question,
            acceptedAnswer: { '@type': 'Answer', text: item.answer },
          })),
        },
        {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: '首页', item: `${window.location.origin}/` },
            { '@type': 'ListItem', position: 2, name: '常见问题', item: `${window.location.origin}/faq` },
          ],
        },
      ],
    },
  });

  return (
    <SiteLayout>
      <section className="border-b border-background-200 bg-background-100">
        <div className="w-full px-4 py-10 md:px-8 md:py-14">
          <Breadcrumb items={[{ label: '常见问题' }]} />
          <h1 className="mt-4 font-heading text-3xl font-black text-foreground-950 md:text-4xl">常见问题</h1>
          <p className="mt-4 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
            关于内容来源、信息状态、讨论区规则与版权处理，我们把最常被问到的问题整理在下面。
          </p>
        </div>
      </section>

      <section className="bg-background-50">
        <div className="w-full px-4 py-12 md:px-8 md:py-14">
          <div className="mx-auto max-w-4xl space-y-10">
            {groupOrder.map((group) => {
              const list = faqs.filter((item) => item.category === group);
              if (list.length === 0) return null;
              return (
                <div key={group}>
                  <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
                    <span className="h-4 w-1 bg-primary-500" aria-hidden="true" />
                    {group}
                  </h2>
                  <div className="mt-4">
                    <FaqAccordion items={list} />
                  </div>
                </div>
              );
            })}
          </div>

          <div className="mx-auto mt-12 max-w-4xl border border-background-200 bg-background-100 p-6 md:flex md:items-center md:justify-between">
            <p className="text-sm text-foreground-600">
              还有别的问题？欢迎直接留言，我们会在核实后补充到这里。
            </p>
            <Link
              to="/contact"
              className="mt-4 inline-block whitespace-nowrap bg-primary-500 px-5 py-2.5 text-sm text-background-50 transition-colors hover:bg-primary-600 md:mt-0"
            >
              联系我们
            </Link>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}